





































import {Component, Vue} from 'vue-property-decorator';

import {mdiSvg} from '../tools';
import MentionsLegales from '../views/MentionsLegales.vue';
import PrivacyPolicy from '../views/PrivacyPolicy.vue';

@Component({components: {PrivacyPolicy, MentionsLegales}})
export default class LegalModal extends Vue {
  svgIcons = mdiSvg;

  window = 1;
}
